export enum QuoteVehicleValuationMethods {
  MARKET_VALUE = 'marketValue',
  AGREED_VALUE = 'agreedValue',
}

export enum VehicleValueType {
  agreedValue = 'Agreed value',
  marketValue = 'Market value',
}
